/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-02-24 19:05:11
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-06 16:55:24
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/tools/commonRequests.ts
 */
import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { addBrand as brandReq } from 'src/request/common/brand';
import { addUnit as unitReq } from 'src/request/common/unit';
import { deleteProducts } from '@/src/request/product/product';
import { message } from 'antd';
import history from 'src/router/history';
import {
  getProduct,
  postProduct,
  activateProduct as reqActivate,
  draftProduct as reqDraft,
  archiveProduct as reArchive,
} from '@/src/request/product/product';
export const addBrand = async (brand) => {
  const newBrand = await brandReq(brand);
  return newBrand;
};
export const addUnit = async (unit) => {
  const newBrand = await unitReq(unit);
  return newBrand;
};
export const deleteProd = (uuid) => {
  const payload = { deletionType: 'Selected', productUuids: [uuid] };
  deleteProducts(payload).then((res) => {
    if (res.length) {
      message.success('delete success');
      history.push({
        pathname: '/productsList',
        state: { skipNotice: true },
      });
    }
  });
};
export const fetchProduct = createAsyncThunk(
  'fetchProduct',
  async (uuid: string) => {
    const response = await getProduct(uuid);
    return response;
  },
);

export const submitProductThunk = createAsyncThunk(
  'submitProduct',
  async (obj: any) => {
    const { prod, hideMsg } = obj;
    const response = await postProduct(prod);
    return { response, hideMsg };
  },
);

export const activateProductThunk = createAsyncThunk(
  'activateProduct',
  async (prod: any) => {
    const response = await reqActivate(prod);
    return response;
  },
);
export const draftProductThunk = createAsyncThunk(
  'draftProduct',
  async (prod: any) => {
    const response = await reqDraft(prod);
    return response;
  },
);
export const archiveProductThunk = createAsyncThunk(
  'archiveProduct',
  async (prod: any) => {
    const response = await reArchive(prod);
    return response;
  },
);

export const generateActivateProductThunk = (key) =>
  createAsyncThunk(key || 'activateProduct', async (prod: any) => {
    const response = await reqActivate(prod);
    return response;
  });
export const generateDraftProductThunk = (key) =>
  createAsyncThunk(key || 'draftProduct', async (prod: any) => {
    const response = await reqDraft(prod);
    return response;
  });
export const generateArchiveProductThunk = (key) =>
  createAsyncThunk(key || 'archiveProduct', async (prod: any) => {
    const response = await reArchive(prod);
    return response;
  });

export const generateSubmitThunk = (key) =>
  createAsyncThunk(key || 'submitProduct', async (obj: any) => {
    const { prod, hideMsg, ...rest } = obj;
    const response = await postProduct(prod);
    return { response, hideMsg, ...rest };
  });

export const generateDuplicateThunk = (key) =>
  createAsyncThunk(key || 'duplicateProduct', async (obj: any) => {
    const { prod, hideMsg, ...rest } = obj;

    // const response = await postProduct(prod);
    return { response: prod, hideMsg, ...rest };
  });

export const generateFetchThunk = (key) =>
  createAsyncThunk(key || 'fetchProduct', async (uuid: string) => {
    const response = await getProduct(uuid);
    return response;
  });

export const duplicateProduct = createAction('duplicateProduct', (prod) => {
  const { productType, name, status } = prod;

  return { payload: { productType, name, status } };
});
